import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { MappedLoanOfficer } from '@/services/mappers/loanOfficer.mapper';

interface LoanOfficersState {
  officers: MappedLoanOfficer[];
  total: number;
  isLoading: boolean;
  error: string | null;
}

const initialState: LoanOfficersState = {
  officers: [],
  total: 0,
  isLoading: false,
  error: null,
};

const loanOfficersSlice = createSlice({
  name: 'loanOfficers',
  initialState,
  reducers: {
    setLoanOfficers: (
      state,
      action: PayloadAction<{ officers: MappedLoanOfficer[]; total: number }>
    ) => {
      state.officers = action.payload.officers;
      state.total = action.payload.total;
      state.error = null;
    },
    setLoanOfficersLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setLoanOfficersError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearLoanOfficers: (state) => {
      state.officers = [];
      state.total = 0;
      state.error = null;
    },
  },
});

export const {
  setLoanOfficers,
  setLoanOfficersLoading,
  setLoanOfficersError,
  clearLoanOfficers,
} = loanOfficersSlice.actions;

export default loanOfficersSlice.reducer;
